module.exports = __webpack_public_path__ + "img/majorRoadWay.71b13433.svg";